import React, { useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";

import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from "@material-ui/core/Typography";

import moment from "moment";
import { ErrorMessage } from '@hookform/error-message';
import {
  MUISortOptions,
  SelectableRows,
} from "mui-datatables";

import { ApolloBreadcrumbs } from "../../atom/Apollo_Breadcrumbs";
import {
  ApolloEventRecord,
  handleSuccessEventLog,
  handleFailureEventLog,
} from "../../atom/Apollo_EventRecord";
import {
  ApolloMessage,
  CustomizedSnackbars,
  setLoadingMessage,
  setSuccessMessage,
  setErrorMessage,
  setErrorMessageTypeAll,
  setWarningMessage,
} from "../../atom/Apollo_Mesasge";
import { ApolloExpired } from "../../atom/Apollo_Expired";
import {
  apollo_useStyles,
  options_extract_period_kind,
  weekKeys,
  options_performance_report_ad_kind,
  options_performance_report_totaling_period_kind,
  options_analysis_report_option,
  options_analysis_report_totaling_period_kind,
  Option,
} from "../../atom/Apollo_styles";
import {
  ColoredOption,
  options_extract_frequency_kind,
  options_report_kind,
  options_demographic_report_output_case_lebel,
  options_demographic_report_extract_period_kind,
  options_extract_day,
  options_menu_kind,
  options_menu_campaign_kind,
  options_edit_repeat_status,
} from "../../atom/Apollo_Options";
import {
  apollo_reports_path,
  apollo_report_setting_path,
  apollo_report_rerun_path,
  apollo_report_campaign_names_path,
  apollo_report_output_columns_master_path,
  apollo_setpoints_path,
} from "../../atom/Apollo_links";
import {
  ApolloAxios,
} from "../../atom/Apollo_ApiRequest3";
import { ApolloContext } from "../../atom/Apollo_Context";
import {
  ApolloDataTable,
  STORAGE_KEY,
} from "../../atom/Apollo_DataTable";
import {
  ApolloDialog,
  ApolloDialogButton,
} from "../../atom/Apollo_Dialog";
import {
  RESULT_CODE,
  MSG,
  REPORT_KIND,
  OUTPUT_CASE_LEBEL,
  AGGREGATION_UNIT,
  DEMOGRAPHIC_REPORT_KIND,
  EXTRACT_PERIOD_KIND,
  EXTRACT_FREQUENCY_KIND,
  SCHEDULE_KIND,
  REPEAT_STATUS,
  REPORT_STATUS,
  NUMBER,
  CHECKBOX_STATE,
  ZERO,
  BLANK,
  RESULT_SETPOINT_ERROR,
  UNDER_SCORE,
  COMMA,
  NULL_YEAR,
  DATETIME_SCHEDULED,
  WEEK,
  DAY,
  INVALID_DATE,
  UNNAMED_REPORT,
  INIT_EXTRACT_WEEK,
  REPORT_SCHEDULE_END_DATE_MAX,
  REPORT_DEFAULT_SCHEDULE_END_DATE,
  DEMOGRAPHIC_REPORT_MAX_PERIOD,
  REPORT_OUTPUT_COLUMNS,
  REPORT_PERIOD_AUTO_CHANGE_MSG,
  REPORT_PERIOD_START_DEFAULT_VALUE_SET_MSG,
  REPORT_PERIOD_END_DEFAULT_VALUE_SET_MSG,
} from "../../common/Apollo_CommonConst_Beta";
import {
  valueToLabel,
  sortByUnderscoreParts,
  checkInvalidCharForReportName,
} from "../../common/Apollo_CommonUtil_Beta";
import {
  ApolloBasicSelect,
  ApolloBasicTextField,
  ApolloBasicRadio,
  ApolloBasicCheck,
  ApolloBasicPeriod
} from "../../molecule/Apollo_BaseItem";
import ApolloReportDownload from "../../molecule/REPORT/Apollo_ReportDownload";
import { ApolloButtonBaseDelete } from "../../molecule/Apollo_ButtonBase";
import {
  ApolloOutputColumnDialog,
  filterOutputColumns,
  resetOutputColumns,
  isSetOutputColumns,
} from "../../organism/REPORT/Output_Column_Dialog";
import {
  createUserEventLogData,
} from "./ReportCreate";
import {
  ReportSetting,
  Report,
  ReportSettingRequest,
  CampaignList,
} from "./ReportModel";
import GenericTemplate from "../../templates/GenericTemplate";
import {                       // 追加：権限判定
  APOLLO_PROFILE_SYSTEM_ADMIN,
  APOLLO_SYSTEM_ADMIN,
  IsAuthorization,
} from "../../atom/Apollo_Authorization";

// 今月初
const startThisMonth = `${moment().startOf("month").format("YYYY/MM/DD HH:mm")}:00`;
// 今月末
const endThisMonth = `${moment().endOf("month").format("YYYY/MM/DD HH:mm")}:00`;
// 翌日初
const startNextDay = `${moment().add(1, "day").startOf("day").add(10, 'hours').format("YYYY/MM/DD HH:mm")}:00`;
// スケジュールの終了日
const scheduleEndDay = `${moment().add(REPORT_DEFAULT_SCHEDULE_END_DATE, 'day').startOf('day').format("YYYY/MM/DD HH:mm")}:00`;

const initReport: ReportSetting = {
  reportSettingId: ZERO,
  reportName: BLANK,
  accountgroupId: ZERO,
  accountgroupName: BLANK,
  accountName: BLANK,
  accountId: ZERO,
  reportKind: REPORT_KIND.PERFORMANCE,
  menuCampaignKind: [],
  status: ZERO,
  outputCaseLebel: OUTPUT_CASE_LEBEL.CAMPAIGN,
  aggregationUnit: AGGREGATION_UNIT.SUM_TOTAL,
  option: DEMOGRAPHIC_REPORT_KIND.AGE_GENDER,
  extractPeriodKind: EXTRACT_PERIOD_KIND.CURRENT_MONTH,
  extractFrequencyKind: EXTRACT_FREQUENCY_KIND.WEEKLY,
  extractDay: NUMBER.ONE,
  startAt: startThisMonth,
  endAt: endThisMonth,
  scheduleKind: SCHEDULE_KIND.REPEAT,
  extractWeek: INIT_EXTRACT_WEEK,
  scheduledAt: startNextDay,
  scheduledEndAt: scheduleEndDay,
  createdBy: BLANK,
  createdAt: BLANK,
  period: BLANK,
  modifiedBy: BLANK,
  modifiedAt: BLANK,
  repeatStatus: ZERO,
  outputColumn: REPORT_OUTPUT_COLUMNS.MASTER.join(COMMA),
};

const ReportDetail: React.FC = () => {
  // context
  const { data: msg, setmsg } = React.useContext(ApolloMessage);
  const { state: apolloContex } = React.useContext(ApolloContext);

  // current
  const accountId = apolloContex.current.accountId;

  // useStyle
  const classes = apollo_useStyles();

  // useForm
  const { register, handleSubmit, control, setError, errors, clearErrors, setValue } = useForm({
    reValidateMode: "onBlur",
  });

  // history
  const history = useHistory();
  const handleGoback = () => {
    history.goBack();
  };
  const goToReport = () => history.push(apollo_reports_path);

  // useState
  const [progress, setProgress] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [campaignList, setCampaignList] = useState<CampaignList[]>([]);
  const [selectedMenus, setSelectedMenus] = useState<number[]>([]);
  const [selectedCampaignKinds, setSelectedCampaignKinds] = useState<string[]>([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState<ColoredOption[]>([]);
  const [openOutputColumnDialog, setOpenOutputColumnDialog] = useState(false);
  const [report, setReport] = useState<ReportSetting>(initReport);
  const [reportOld, setReportOld] = useState<ReportSetting>(initReport)
  const [reports, setReports] = useState<Report[]>([]);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [previousRepeatStatus, setPreviousRepeatStatus] = useState<number>(REPEAT_STATUS.RUNNING);
  const [outputColumnsMaster, setOutputColumnsMaster] = useState<Option[]>([])

  // 開始、終了 テキストボックスコンポーネント更新用
  const [updatePriodItemTrigger, setUpdatePriodItemTrigger] = useState(moment());
  const [priodStarMessageInfo, setPriodStarMessageInfo] = useState(BLANK);
  const [priodEndessageInfo, setPriodEndessageInfo] = useState(BLANK);
  
  // etc
  const {reportSettingId} = useParams<{reportSettingId: string}>();
  const extractWeekJson = report.extractWeek ? (JSON.parse(report.extractWeek) as number[]) : [];

  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
  const now = moment();
  const cutoff  = moment("2025-09-30 23:59", "YYYY-MM-DD HH:mm");
  const octStart = moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm");
  const octEnd   = moment("2025-10-31 23:59", "YYYY-MM-DD HH:mm");
  const oct7End  = moment("2025-10-07 23:59", "YYYY-MM-DD HH:mm");
  const isBeforeCutoff = !isAuthorization && now.isSameOrBefore(cutoff);
  const customInitDoneRef = React.useRef(false);

  // columns
  const columns = [
    {
      name: "reportId",
      label: "レポートID",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "outputCaseLebel",
      label: "出力粒度",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToLabel(value, options_performance_report_ad_kind);
        },
      },
    },
    {
      name: "aggregationUnit",
      label: "集計単位",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToLabel(value,options_performance_report_totaling_period_kind);
        },
      },
    },
    {
      name: "extractPeriodKind",
      label: "期間指定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return valueToLabel(value, options_extract_period_kind);
        },
      },
    },
    {
      name: "period",
      label: "抽出期間",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "extractFrequencyKind",
      label: "抽出頻度",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          const label = valueToLabel(value, options_extract_frequency_kind)
          return label ? label : DATETIME_SCHEDULED;
        }
      },
    },
    {
      name: "scheduleKind",
      label: "スケジュール",
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          const { scheduleKind, extractFrequencyKind, extractWeek, extractDay, scheduledAt } = reports[idx];

          if (scheduleKind === SCHEDULE_KIND.REPEAT) {
            if (extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY) {
              const extractWeekJson = extractWeek ? JSON.parse(extractWeek) as number[] : [];
              const extractWeekStr = weekKeys.filter((_, index) => extractWeekJson[index] === CHECKBOX_STATE.CHECKED).join(COMMA);
              return extractWeekStr.length === NUMBER.ONE ? `${extractWeekStr}${WEEK}` : extractWeekStr;
            }
            return `${extractDay}${DAY}`;
          }

          return moment(scheduledAt).format("YYYY/MM/DD HH:mm");
        }
      }
    },
    {
      name: "extractedAt",
      label: "作成日時",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string | null) => {
          var date = "-";
          if (moment(value).format("YYYY") !== NULL_YEAR) {
            date = moment(value).format("YYYY/MM/DD HH:mm");
          }
          return date;
        },
      },
    },
    {
      name: "download",
      label: "ダウンロード",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return <ApolloReportDownload report={reports[idx]} />;
        },
      },
    },
    {
      name: "",
      label: "再実行",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Button
              variant="contained"
              color="primary"
              disabled={reports[idx].reportStatus !== REPORT_STATUS.FAILURE}
              onClick={() => handleRerun(reports[idx].reportId)}>
              再実行
            </Button>
          );
        },
      },
    },
  ];

  // options
  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "reportId",
    direction: "desc",
  });
  const [numberOfRows, setNumberOfRows] = useState(10);
  const selectableRows: SelectableRows = "none";
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10],
    jumpToPage: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.CREATED_REPORT,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions);
    },
    onChangeRowsPerPage: (numberOfRows: number) =>
      setNumberOfRows(numberOfRows),
  };

  // レポート設定取得
  useEffect(() => {
    setProgress(true);
    setIsDataLoaded(false);
    setmsg(setLoadingMessage(msg, true));
    // ApolloAPIとの接続

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_setting_path}/${accountId}/${reportSettingId}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        if (response.data.result) {
          resetReport(response.data.result);
        }
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_REPORT_SETTING));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_REPORT_SETTING, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      setmsg(setLoadingMessage(msg, false));
      setIsDataLoaded(true);
    });
  }, []);

  // 出力済みレポート一覧取得
  useEffect(() => {
    setProgress(true);
    setmsg(setLoadingMessage(msg, true));
    getReports();
  }, []);

  // キャンペーン一覧取得
  useEffect(() => {
    if (report.accountId <= ZERO || !isDataLoaded) return
    setProgress(true);
    setmsg(setLoadingMessage(msg, true));

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_campaign_names_path}/${report.accountId}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        if (!response.data.result) {
          setCampaignList([]);
        } else {
          setCampaignList(response.data.result);
        }
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_CAMPAIGN));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_CAMPAIGN, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
    .finally(() => {
    });
  }, [isDataLoaded])

  useEffect(() => {
    if (report.accountId <= ZERO || !isDataLoaded) return

    const fetchSetPoints = () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_setpoints_path}/${report.accountId}`;
      ApolloAxios.get(url).then((response) => {
        if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
          setmsg(setErrorMessage(msg, `${MSG.ERROR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`));
        } else if (response.data.result) {
          const newSetPoints: Option[] = [];
          const newDeletedSetPoints: Option[] = [];
          response.data?.result?.map(function (data: { setPointId: number, setPointName: string, setPointDeleteFlg: number }) {
            const option: Option = {
              value: data.setPointId,
              label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}`,
            }
            if (data.setPointDeleteFlg === 0) {
              newSetPoints.push(option);
            } else {
              newDeletedSetPoints.push(option);
            }
          });
          setSetPoints(newSetPoints);
          setDeletedSetPoints(newDeletedSetPoints);
        }
      }).catch(err => {
        setmsg(setErrorMessage(msg, `${MSG.ERROR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`));
      }).finally(() => {
        setmsg(setLoadingMessage(msg, false));
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchSetPoints()]
      ).finally(() => {
        setProgress(false);
      })
    }
    fetchAll();
  }, [isDataLoaded]);

  // 出力カラムマスタ取得
  useEffect(() => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_output_columns_master_path}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        const newOutputColumnsMaster: Option[] = [];
        response.data?.result?.map(function (data: { id: number, label: string}) {
          const option: Option = {
            value: data.id,
            label: data.label,
          }
          newOutputColumnsMaster.push(option);
        });
        setOutputColumnsMaster(newOutputColumnsMaster);
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_REPORT_OUTPUT_COLUMNS_MASTER));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_REPORT_OUTPUT_COLUMNS_MASTER, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }, [])

  // 表示データ変更Effect
  useEffect(() => {
    if (report.accountId <= ZERO || !isDataLoaded) return
    createOption();
  }, [campaignList]);

  const setPeriod = (dataList: Report[]) => {
    const localData = dataList.map((data) => {
      data.period = "-";
      if (moment(data.startAt).format("YYYY") !== NULL_YEAR) {
        data.period = `${moment(data.startAt).format("YYYY/MM/DD")} - ${moment(data.endAt).format("YYYY/MM/DD")}`;
      }
      return data;
    });
    setReports(localData);
  };

  // レポート設定情報を初期化する
  const resetReport = (localReport : ReportSetting) => {
    // 期間指定がカスタム選択以外の場合、日時を初期化する
    if (localReport.extractPeriodKind !== EXTRACT_PERIOD_KIND.CUSTOM) {
      localReport.startAt = initReport.startAt;
      localReport.endAt = initReport.endAt;
    }
    // スケジュール種別が日付指定以外の場合、日時を初期化する
    if (localReport.scheduleKind !== SCHEDULE_KIND.SCHEDULED) {
      localReport.scheduledAt = initReport.scheduledAt;
      setPreviousRepeatStatus(localReport.repeatStatus);
    } else {
      localReport.scheduledEndAt = initReport.scheduledEndAt;
    }
    localReport.outputColumn = resetOutputColumns(localReport.outputColumn, localReport.reportKind, localReport.outputCaseLebel);
    setReport(localReport);
    setReportOld(localReport);
  }

  const getReports = () => {
    // ApolloAPIとの接続
    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_reports_path}/${accountId}/${reportSettingId}`
    ApolloAxios.get(url)
      .then((response) => {
        if (response.data.resultCode === RESULT_CODE.SUCCESS) {
          setmsg(setLoadingMessage(msg, false));
          if (response.data.result) {
            setPeriod(response.data.result);
          } else {
            setPeriod([]);
          }
        } else {
          setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_REPORT));
        }
      })
      .catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, MSG.ERROR_GET_REPORT, msg, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      })
      .finally(() => {
        setmsg(setLoadingMessage(msg, false));
      });
  }

  const createOption = () => {
    var local_menu_values: number[] = [];
    var local_campaign_kind_values: string[] = [];
    var local_campaign_values: ColoredOption[] = [];
    for (const menu of report.menuCampaignKind) {
      const menuId = menu.menuId;
      if (!local_menu_values.includes(menuId)) {
        local_menu_values.push(menuId);
      }

      const menu_option = options_menu_kind.find((c) => c.value === menuId);
      if (!menu_option) {
        continue;
      }

      const campaignKindId = menu.campaignKindId;
      const campaignKindValue = `${menuId}${UNDER_SCORE}${campaignKindId}`;
      if (campaignKindId > 0 && !local_campaign_kind_values.includes(campaignKindValue)) {
        local_campaign_kind_values.push(campaignKindValue);
      }

      const campaignId = menu.campaignId;
      if (campaignId <= ZERO) {
        continue;
      }

      const campaign = campaignList.find((c) => c.id === campaignId && c.platform === menuId);
      if (campaign) {
        const campaignValue = `${menuId}${UNDER_SCORE}${campaignKindId}${UNDER_SCORE}${campaignId}`;
        const campaignLabel = `${campaign.id}${UNDER_SCORE}${campaign.name}`
        const option: ColoredOption = {
          value: campaignValue,
          label: campaignLabel,
          color: menu_option.color,
        };

        local_campaign_values.push(option);
      }
    }

    local_campaign_values = sortByUnderscoreParts(local_campaign_values);

    setSelectedMenus(local_menu_values);
    setSelectedCampaignKinds(local_campaign_kind_values);
    setSelectedCampaigns(local_campaign_values);
  };

  const handleChangeOption = (event: any) => {
    setReport({ ...report, extractFrequencyKind: Number(event.target.value) });
  };

  const handleCloseOutputColumn = () => {
    if (openOutputColumnDialog) setOpenOutputColumnDialog(false);
  }

  // 更新リクエスト
  const onSubmit = handleSubmit(() => {

    // バリデーション
    let hasError = false;

    // レポート種別
    if (report.reportKind === ZERO) {
      setError("reportKind", {
        type: "manual",
        message: MSG.VALIDATE_REQUIRED,
      })
      hasError = true;
    }
    // メニューキャンペーン種別
    if (report.menuCampaignKind.length <= ZERO) {
      setError("menuCampaignKind", {
        type: "manual",
        message: MSG.VALIDATE_REQUIRED,
      })
      hasError = true;
    }
    // 出力粒度
    if (report.outputCaseLebel === ZERO) {
      setError("outputCaseLebel", {
        type: "manual",
        message: MSG.VALIDATE_REQUIRED,
      })
      hasError = true;
    }

    // レポート種別が分析レポート選択時
    if (report.reportKind === REPORT_KIND.DEMOGRAPHIC) {
      // 出力粒度に広告は選択できない
      if (report.outputCaseLebel === OUTPUT_CASE_LEBEL.ADVERTISEMENT) {
        setError("outputCaseLebel", {
          type: "manual",
          message: MSG.VALIDATE_ADVERTISEMENT_NOT_ALLOWED,
        })
        hasError = true;
      }
      // 集計単位に時間は選択できない
      if (report.aggregationUnit === AGGREGATION_UNIT.HOUR) {
        setError("aggregationUnit", {
          type: "manual",
          message: MSG.VALIDATE_HOUR_NOT_ALLOWED,
        })
        hasError = true;
      }
    }

    // 期間指定がカスタム選択時、開始・終了の入力があるか
    if (report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM) {
      if (!report.startAt || report.startAt === INVALID_DATE) {
        setError("startAt", {
          type: "manual",
          message: MSG.VALIDATE_START_AT,
        })
        hasError = true;
      } else if (!report.endAt || report.endAt === INVALID_DATE) {
        setError("endAt", {
          type: "manual",
          message: MSG.VALIDATE_END_AT,
        })
        hasError = true;
      }
      // 開始・終了の大小チェック
      if (!hasError) {
        if (moment(report.startAt) > moment(report.endAt)) {
          setError("startAt", {
            type: "manual",
            message: MSG.VALIDATE_START_DATE_BEFORE_END_DATE,
          })
          setError("endAt", {
            type: "manual",
            message: MSG.VALIDATE_END_DATE_AFTER_START_DATE,
          })
          hasError = true;
        } else {
          if (report.reportKind === REPORT_KIND.PERFORMANCE) {
            // 期間13ヶ月以内チェック
            var date13 = moment(report.startAt).add(1, 'years').add(1, 'months');
            if (date13 < moment(report.endAt)) {
              setError("endAt", {
                type: "manual",
                message: MSG.VALIDATE_DURATION_MONTHS,
              })
              hasError = true;
            }
          } else if (report.reportKind === REPORT_KIND.DEMOGRAPHIC) {
            const startAt = moment(report.startAt).startOf('day');
            const endAt = moment(report.endAt).startOf('day');
            if (endAt.diff(startAt, 'days') >= DEMOGRAPHIC_REPORT_MAX_PERIOD) {
              setError("startAt", {
                type: "manual",
                message: MSG.VALIDATE_DURATION_DAYS,
              })
              setError("endAt", {
                type: "manual",
                message: MSG.VALIDATE_DURATION_DAYS,
              })
              hasError = true;
            }
          }
        }
      }
    }

    // スケジュール種別が繰り返し選択時、曜日選択されているか
    if (report.scheduleKind === SCHEDULE_KIND.REPEAT) {
      if (report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY && report.extractWeek === INIT_EXTRACT_WEEK) {
        setError("extractWeek", {
          type: "manual",
          message: MSG.VALIDATE_EXTRACT_WEEK,
        })
        hasError = true;
      }

      if (!report.scheduledEndAt || report.scheduledEndAt === INVALID_DATE) {
        setError("scheduledEndAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_END_AT,
        })
        hasError = true;
      }

      if (report.repeatStatus === REPEAT_STATUS.RUNNING) {
        const today = moment().startOf('day');
        const expiredAt = today.clone().add(REPORT_SCHEDULE_END_DATE_MAX, 'days').endOf('day');
        const scheduledEndAt = moment(report.scheduledEndAt);

        if (scheduledEndAt.diff(today) < ZERO) {
          setError("scheduledEndAt", {
            type: "manual",
            message: MSG.VALIDATE_SCHEDULED_END_AT_RESTRICTION,
          })
          hasError = true;
        }

        if (expiredAt.diff(scheduledEndAt) < ZERO) {
          setError("scheduledEndAt", {
            type: "manual",
            message: MSG.VALIDATE_SCHEDULE_END_DATE_MAX,
          })
          hasError = true;
        }
      }
    }

    // スケジュール種別が日付指定時、時刻指定されているか
    if (report.scheduleKind === SCHEDULE_KIND.SCHEDULED) {
      if (!report.scheduledAt || report.scheduledAt === INVALID_DATE) {
        setError("scheduledAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_AT,
        })
        hasError = true;
      }

      const restrictedAt = moment().add(1, 'hour').startOf('hour');
      const scheduledAt = moment(report.scheduledAt);
      if (scheduledAt.diff(restrictedAt) < ZERO) {
        setError("scheduledAt", {
          type: "manual",
          message: MSG.VALIDATE_SCHEDULED_AT_RESTRICTION,
        })
        hasError = true;
      }
    }

    var workOutputColumn = filterOutputColumns(report.outputColumn, report.reportKind, report.outputCaseLebel)
    if (workOutputColumn === BLANK) {
      setError("outputColumn", {
        type: "manual",
        message: MSG.VALIDATE_OUTPUT_COLUMN,
      })
      hasError = true;
    }

    // 入力エラーがある場合は、リクエストを送らない
    if (hasError) return;

    // リクエスト
    var workStartAt = report.startAt ? moment(report.startAt).toISOString() : null;
    var workEndAt = report.endAt ? moment(report.endAt).toISOString() : null;
    var workScheduledAt = report.scheduledAt ? moment(report.scheduledAt).toISOString() : null;
    var workScheduledEndAt = report.scheduledEndAt ? moment(report.scheduledEndAt).toISOString() : null;

    var executeLogData = createUserEventLogData(apolloContex, "予約レポート詳細画面", "更新", reportSettingId, reportOld, report);
    ApolloEventRecord(executeLogData);

    const reportSettingUpdateRequest: ReportSettingRequest = {
      reportName: report.reportName  === BLANK ? UNNAMED_REPORT : report.reportName,
      accountgroupId: report.accountgroupId,
      accountId: report.accountId,
      reportKind: report.reportKind,
      menuCampaignKind: report.menuCampaignKind,
      outputCaseLebel: report.outputCaseLebel,
      aggregationUnit: report.aggregationUnit,
      option: report.reportKind === REPORT_KIND.DEMOGRAPHIC ? report.option : null,
      extractPeriodKind: report.extractPeriodKind,
      startAt: report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM ? workStartAt : null,
      endAt: report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM ? workEndAt : null,
      scheduleKind: report.scheduleKind,
      extractFrequencyKind: report.scheduleKind === SCHEDULE_KIND.REPEAT ? report.extractFrequencyKind : ZERO,
      extractDay: report.scheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.MONTHLY ? report.extractDay : ZERO,
      extractWeek: report.scheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY ? report.extractWeek : BLANK,
      scheduledAt: report.scheduleKind === SCHEDULE_KIND.SCHEDULED ? workScheduledAt : null,
      scheduledEndAt: report.scheduleKind === SCHEDULE_KIND.REPEAT ? workScheduledEndAt : null,
      outputColumn: workOutputColumn,
      status: ZERO,
      repeatStatus: report.scheduleKind === SCHEDULE_KIND.REPEAT ? report.repeatStatus : ZERO,
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_setting_path}/${accountId}/${reportSettingId}`
    ApolloAxios.put(url, reportSettingUpdateRequest).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        handleSuccessEventLog(executeLogData);
        setmsg(setSuccessMessage(msg, MSG.SUCCESS_PUT_REPORT_SETTING));
        handleGoback();
      } else {
        handleFailureEventLog(executeLogData);
        setmsg(setErrorMessage(msg, MSG.ERROR_PUT_REPORT_SETTING));
      }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, MSG.ERROR_PUT_REPORT_SETTING, msg, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      })
  });

  // 削除リクエスト
  const handleDelete = async () => {
    var executeLogData = createUserEventLogData(apolloContex, "予約レポート詳細画面", "削除", reportSettingId, reportOld, null);
    ApolloEventRecord(executeLogData);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_setting_path}/${accountId}/${reportSettingId}`
    ApolloAxios.delete(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        handleSuccessEventLog(executeLogData);
        setmsg(setSuccessMessage(msg, MSG.SUCCESS_DELETE_REPORT_SETTING));
        handleGoback();
      } else {
        handleFailureEventLog(executeLogData);
        setmsg(setErrorMessage(msg, MSG.ERROR_DELETE_REPORT_SETTING));
      }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, MSG.ERROR_DELETE_REPORT_SETTING, msg, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      })
  };

  //レポート出力再実行リクエスト
  const handleRerun = (reportId: number) => {
    setProgress(true);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_report_rerun_path}/${accountId}/${reportId}`
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setSuccessMessage(msg, MSG.SUCCESS_GET_REPORT_RERUN));
        getReports();
      } else if (response.data.resultCode === RESULT_CODE.BUSY_ERROR) {
        setmsg(setWarningMessage(msg, MSG.WARNING_REPORT_REALTIME_BUSY));
      } else {
        setmsg(setErrorMessage(msg, MSG.ERROR_GET_REPORT_RERUN));
      }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, MSG.ERROR_GET_REPORT_RERUN, msg, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        setProgress(false);
      });
  }

  // 期間指定（extractPeriodKind）候補
  const baseExtractOptions =
    report.reportKind === REPORT_KIND.PERFORMANCE
      ? options_extract_period_kind
      : options_demographic_report_extract_period_kind;
  
  const extractPeriodOptions = React.useMemo(() => {
    let opts = baseExtractOptions;
    if (!isAuthorization && report.scheduleKind === SCHEDULE_KIND.SCHEDULED) {
      const sa = moment(report.scheduledAt);
      if (sa.isValid()) {
        const disallow = new Set<number>();
        // 〜10/31 は「前月」不可
        if (sa.isSameOrBefore(octEnd)) disallow.add(EXTRACT_PERIOD_KIND.LAST_MONTH);
        // 10/1 は「前日」不可（※パフォーマンスのみ存在）
        if (sa.isSame(octStart, "day")) disallow.add(EXTRACT_PERIOD_KIND.LAST_DAY);
        // 〜10/7 は「過去7日間」不可
        if (sa.isSameOrBefore(oct7End)) disallow.add(EXTRACT_PERIOD_KIND.LAST_SEVEN_DAYS);
        if (disallow.size > 0) {
          opts = opts.filter((o: any) => !disallow.has(o.value));
        }
      }
    }
    return opts;
  }, [baseExtractOptions, report.scheduleKind, report.scheduledAt, isAuthorization, octEnd, octStart, oct7End]);
  
  // 候補から外れた値を選んでいたらメッセージを出しつつ自動補正
  useEffect(() => {
    if (
      extractPeriodOptions.length > 0 &&
      !extractPeriodOptions.some((o: any) => o.value === report.extractPeriodKind)
    ) {
      setReport((prev) => ({ ...prev, extractPeriodKind: extractPeriodOptions[0].value }));
    }
  }, [extractPeriodOptions, report.extractPeriodKind, report.scheduleKind, isAuthorization, msg, setmsg, setReport]);

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80} />
      </Backdrop>
      <ApolloBreadcrumbs bread_no={78} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""} platform={""}/>

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <form noValidate onSubmit={onSubmit}>
            <Card className={classes.root}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <ApolloBasicSelect
                      id={"reportKind"}
                      label="レポート種別"
                      options={options_report_kind}
                      value={report.reportKind}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, reportKind: e })}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <ApolloBasicSelect
                      id={"accountGroupName"}
                      label="アカウントグループ名"
                      options={[{
                        value: report.accountgroupId,
                        label: report.accountgroupName,
                      }]}
                      value={report.accountgroupId}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, accountgroupName: e })}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <ApolloBasicSelect
                      id={"accountName"}
                      label="広告主アカウント名"
                      options={[{
                        value: report.accountId,
                        label: report.accountName,
                      }]}
                      value={report.accountId}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, accountName: e })}
                      disabled={true}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <ApolloBasicTextField
                      id="reportName"
                      label="レポート名"
                      value={report.reportName}
                      error={errors.reportName}
                      inputRef={register({
                        maxLength: {
                          value: 255,
                          message: "255文字以内で入力して下さい。"
                        },
                        validate: (e: string) => {
                          const errorMessage = checkInvalidCharForReportName(e)
                          if(errorMessage) {
                            return errorMessage
                          }
                        },
                      })}
                      setState={(e: any) => setReport({ ...report, reportName: e })}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      メニュー選択
                    </Typography>
                    <div>
                      <ApolloBasicSelect
                        id={"menuList"}
                        label=""
                        isMulti={true}
                        options={options_menu_kind}
                        value={selectedMenus}
                        readOnly={true}
                        control={control}
                        errors={errors}
                        setState={(e: any) => {}}
                        disabled={true}
                        selectStyle={{ maxHeight: "70px", overflowY: "scroll"}}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      キャンペーン種別
                    </Typography>
                    <div>
                      <ApolloBasicSelect
                        id={"campaignKindList"}
                        label=""
                        isMulti={true}
                        options={options_menu_campaign_kind}
                        value={selectedCampaignKinds}
                        readOnly={true}
                        control={control}
                        errors={errors}
                        setState={(e: any) => {}}
                        disabled={true}
                        selectStyle={{ maxHeight: "70px", overflowY: "scroll"}}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      キャンペーン名
                    </Typography>
                    <div>
                      <Select
                        isMulti
                        isDisabled
                        options={selectedCampaigns}
                        value={selectedCampaigns}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            maxHeight: "70px", overflowY: "scroll"
                          }),
                          option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                            return {
                              ...styles,
                              backgroundColor: isDisabled
                              ? undefined
                              : isSelected
                              ? data.color
                              : isFocused
                              ? "#BCD4FF"
                              : undefined,
                              color: isDisabled
                                ? '#ccc'
                                : data.color,
                              cursor: isDisabled ? 'not-allowed' : 'default',
                              ':active': {
                                ...styles,
                                backgroundColor: !isDisabled
                                  ? data.color
                                  : isSelected,
                              },
                            };
                          },
                          multiValue: (styles, { data }) => {
                            return {
                              ...styles,
                            };
                          },
                          multiValueLabel: (styles, { data }) => ({
                            ...styles,
                            color: data.color,
                          }),
                          menuPortal: base => ({...base, zIndex: 9999}),
                        }}
                        components={{
                          MultiValueRemove: () => null
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <ApolloBasicSelect
                      id={"outputCaseLebel"}
                      label="出力粒度"
                      options={report.reportKind === REPORT_KIND.PERFORMANCE ? options_performance_report_ad_kind : options_demographic_report_output_case_lebel}
                      value={report.outputCaseLebel}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, outputCaseLebel: e })}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <ApolloBasicSelect
                      id={"aggregationUnit"}
                      label="集計単位"
                      options={report.reportKind === REPORT_KIND.PERFORMANCE ? options_performance_report_totaling_period_kind : options_analysis_report_totaling_period_kind}
                      value={report.aggregationUnit}
                      control={control}
                      errors={errors}
                      setState={(e: any) => setReport({ ...report, aggregationUnit: e })}
                    />
                  </Grid>
                </Grid>

                {
                  // レポート種別が2: 実績レポートの場合のみ表示
                  report.reportKind === REPORT_KIND.DEMOGRAPHIC
                    ? <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <ApolloBasicRadio
                            id="option"
                            label="オプション"
                            options={options_analysis_report_option}
                            value={report.option}
                            control={control}
                            errors={errors}
                            setState={(e: any) => setReport({ ...report, option: Number(e) })}
                            disabled={true}
                          />
                        </Grid>
                      </Grid>
                    : null
                }

                <Grid container spacing={3}>
                  <Grid item xs={5}>
                    <ApolloBasicRadio
                      id="extractPeriodKind"
                      label="期間指定"
                      options={extractPeriodOptions}
                      value={report.extractPeriodKind}
                      control={control}
                      errors={errors}
                      setState={(e: any) => {
                        const next = Number(e);
                        if (next === EXTRACT_PERIOD_KIND.CUSTOM && !isAuthorization) {
                          const curStart = moment(report.startAt, "YYYY-MM-DD HH:mm:ss", true);
                          const curEnd   = moment(report.endAt,   "YYYY-MM-DD HH:mm:ss", true);
                      
                          const needInit =
                            !customInitDoneRef.current ||             // まだ初期化していない
                            !curStart.isValid() || !curEnd.isValid() || // 値が不正
                            curStart.isBefore(octStart) ||       // 9/30以前が含まれる
                            curEnd.isBefore(octStart);
                      
                          if (needInit) {
                            customInitDoneRef.current = true;
                            setReport(prev => ({
                              ...prev,
                              extractPeriodKind: next,
                              startAt: moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
                              endAt:   moment("2025-10-31 23:59", "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
                            }));
                          } else {
                            // すでにユーザーが10/1以降の値を設定済みなら上書きしない
                            setReport(prev => ({ ...prev, extractPeriodKind: next }));
                          }
                        } else {
                          setReport(prev => ({ ...prev, extractPeriodKind: next }));
                        }
                     }}
                    />
                  </Grid>
                  {report.extractPeriodKind === EXTRACT_PERIOD_KIND.CUSTOM ? (
                    <>
                <ApolloBasicPeriod
                  key={updatePriodItemTrigger.format()}
                  startDate={{
                    id: "startAt",
                    label: "開始",
                    value: moment(report.startAt).format("YYYY-MM-DDTHH:mm"),
                    inputProps: {
                      ...(isAuthorization
                        ? {}
                        : { min: "2025-10-01T00:00" }),
                    },
                    errors: errors.startAt,
                    setState: (e: any) => {
                      const next = moment(
                        e,
                        ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                        true
                      );
                    
                      // 非管理者 & 2025/10/01 00:00 未満なら無視（state を更新しない）
                      setPriodStarMessageInfo(BLANK)

                      const cutoff = moment(  "2025-10-01 00:00", "YYYY-MM-DD HH:mm");

                      if (!isAuthorization && (!next.isValid() || next.isBefore(cutoff))) {

                        const current = moment()
                        const nextValue = current.isBefore(cutoff) ? cutoff.format("YYYY-MM-DD HH:mm:ss") : startThisMonth

                        setReport({ ...report, startAt: nextValue });
                        setPriodStarMessageInfo(REPORT_PERIOD_AUTO_CHANGE_MSG)
                        setmsg(setWarningMessage(msg, REPORT_PERIOD_START_DEFAULT_VALUE_SET_MSG));
                      } else {
                        setReport({ ...report, startAt: next.format("YYYY-MM-DD HH:mm:ss") });
                      }
                      setUpdatePriodItemTrigger(moment())
                      const startAt = moment(e).startOf('day');
                      const endAt = moment(report.endAt).startOf('day');
                      if (report.reportKind === REPORT_KIND.DEMOGRAPHIC && endAt.diff(startAt, 'days') >= DEMOGRAPHIC_REPORT_MAX_PERIOD) {
                        setError("startAt", {
                          type: "manual",
                          message: MSG.VALIDATE_DURATION_DAYS,
                        })
                      } else {
                        clearErrors()
                      }
                    },
                    message: priodStarMessageInfo

                  }}
                  endDate={{
                    id: "endAt",
                    label: "終了",
                    value: moment(report.endAt).format("YYYY-MM-DDTHH:mm"),
                    inputProps: {
                      ...(isAuthorization
                        ? {}
                        : { min: "2025-10-01T00:00" }),
                    },
                    errors: errors.endAt,
                    setState: (e: any) => {
                      const next = moment(
                        e,
                        ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                        true
                      );
                    
                      setPriodEndessageInfo(BLANK)
                      const cutoff = moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm");
                      if (!isAuthorization && (!next.isValid() || next.isBefore(cutoff))) {

                        const current = moment()
                        const nextValue = current.isBefore(cutoff) ? moment("2025-10-31 23:59", "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss") : endThisMonth
                        
                        setPriodEndessageInfo(REPORT_PERIOD_AUTO_CHANGE_MSG)
                        setReport({ ...report, endAt: nextValue });
                        setmsg(setWarningMessage(msg, REPORT_PERIOD_END_DEFAULT_VALUE_SET_MSG));
                      } else {
                        setReport({ ...report, endAt: next.format("YYYY-MM-DD HH:mm:ss") });
                      }
                      setUpdatePriodItemTrigger(moment())
                      const startAt = moment(report.startAt).startOf('day');
                      const endAt = moment(e).startOf('day');
                      if (report.reportKind === REPORT_KIND.DEMOGRAPHIC && endAt.diff(startAt, 'days') >= DEMOGRAPHIC_REPORT_MAX_PERIOD) {
                        setError("endAt", {
                          type: "manual",
                          message: MSG.VALIDATE_DURATION_DAYS,
                        })
                      } else {
                        clearErrors()
                      }
                    },
                    message: priodEndessageInfo
                  }}
                isAuthorization={isAuthorization}
                />
                </>
                  ) : null}
                </Grid>
                {!isAuthorization && (
                  <Grid item xs={12}>
                    <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700 }}>
                      集計範囲に指定可能なのは2025年10月1日以降です。2025年9月30日以前を集計範囲とする場合は、
                      <Button
                        type="button"
                        onClick={goToReport}
                        color="primary"
                        style={{ padding: 0, minWidth: "auto", textDecoration: "underline", fontWeight: "inherit" }}
                      >
                        レポート管理 
                      </Button>
                      をご利用下さい
                    </Typography>
                  </Grid>
                )}

                <Grid container spacing={3}>
                  <Grid xs={5} style={{marginBottom: "25px", display: "flex"}}>
                    <ApolloDialogButton setOpen={setOpenOutputColumnDialog}>
                      <Button type="button" color="primary" variant="contained" className={classes.button}>
                        {"出力カラム設定"}
                      </Button>
                    </ApolloDialogButton>
                    {
                      isSetOutputColumns(report.outputColumn, report.reportKind, report.outputCaseLebel)
                      ?
                      <Typography variant="subtitle1" gutterBottom component="div" className={classes.button} style={{color: "red"}}>
                        {"設定あり"}
                      </Typography>
                      : null
                    }
                    <ErrorMessage
                      errors={errors}
                      name={"outputColumn"}
                      style={{marginTop: "28px"}}
                      as={<Typography variant="caption" className={classes.errorMessage}/>}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  {report.scheduleKind === SCHEDULE_KIND.REPEAT ? (
                  <>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        抽出頻度
                      </Typography>
                      <RadioGroup style={{marginLeft: "17px"}} value={report.extractFrequencyKind} onChange={handleChangeOption} row>
                        {options_extract_frequency_kind.map((v) => (
                            <FormControlLabel
                              value={v.value}
                              control={<Radio disabled/>}
                              label={v.label}
                            />
                        ))}
                      </RadioGroup>
                    </Grid>
                  </>
                  ) : null}
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography>
                      {previousRepeatStatus == REPEAT_STATUS.RUNNING ? "スケジュール": "スケジュール（※繰り返し停止中）"}
                    </Typography>
                  </Grid>

                  {
                    report.scheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.WEEKLY
                    ? <Grid item xs={12} style={{marginLeft: "15px"}}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        曜日指定
                      </Typography>
                      {weekKeys.map((weekKey, index) => {
                        return (
                          <ApolloBasicCheck
                            id={`extractWeek${index}`}
                            key={index}
                            label={weekKey}
                            checked={extractWeekJson[index]}
                            labelPlacement={"end"}
                            setState={
                              (e: any) => {
                                setReport({
                                  ...report,
                                  extractWeek: JSON.stringify(extractWeekJson.map((val, idx) => index === idx ? (e ? 1 : 0) : (val ? 1 : 0)))
                                })
                              }
                            }
                          />
                        )
                      })}
                      <ErrorMessage
                        errors={errors}
                        name={"extractWeek"}
                        as={<Typography variant="caption" className={classes.errorMessage}/>}
                      />
                    </Grid>
                  : report.scheduleKind === SCHEDULE_KIND.SCHEDULED
                    ? <Grid item xs={3} style={{marginLeft: "15px"}}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        日時指定
                      </Typography>
                      <ApolloBasicTextField
                        id="scheduledAt"
                        label=""
                        value={moment(report.scheduledAt).format("YYYY-MM-DDTHH:00")}
                        type="datetime-local"
                        error={errors.scheduledAt}
                        setState={(e: any) => {
                          const next = moment(
                            e,
                            ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                            true
                          );
                        
                          const cutoff = moment("2025-10-01 00:00", "YYYY-MM-DD HH:mm");
                          if (!isAuthorization && (!next.isValid() || next.isBefore(cutoff))) {
                            return;
                          }
                        
                          setReport({ ...report, scheduledAt: next.format("YYYY-MM-DD HH:mm:ss") });
                        }}
                        inputProps={{
                          inputProps: { step: 1800 , views:['year', 'month', 'day', 'hour']},
                          ...(isBeforeCutoff ? { min: "2025-10-01T00:00" } : {}),
                        }}
                      />
                    </Grid>
                  : report.scheduleKind === SCHEDULE_KIND.REPEAT && report.extractFrequencyKind === EXTRACT_FREQUENCY_KIND.MONTHLY
                    ? (
                      <>
                        <Grid item xs={1} style={{marginLeft: "15px"}}>
                          <ApolloBasicSelect
                            id={"extractDay"}
                            label={"日付指定"}
                            options={options_extract_day}
                            value={report.extractDay}
                            control={control}
                            errors={errors}
                            setState={(e: any) => setReport({ ...report, extractDay: e })}
                          />
                        </Grid>

                        <Grid item xs={1} style={{marginTop: "35px"}}>
                          <Typography style={{fontSize: "20px"}} variant="subtitle1" gutterBottom component="div">
                            {DAY}
                          </Typography>
                        </Grid>
                      </>
                    ) : null
                  }
                </Grid>

                {report.scheduleKind === SCHEDULE_KIND.REPEAT ? (
                  <>
                    <Grid container spacing={3}>
                      <Grid item xs={3} style={{marginTop: "20px"}}>
                        <ApolloBasicTextField
                          id="scheduledEndAt"
                          label="スケジュールの終了日"
                          value={moment(report.scheduledEndAt).format("YYYY-MM-DD")}
                          type="date"
                          error={errors.scheduledEndAt}
                          setState={(e: any) => setReport({ ...report, scheduledEndAt: moment(e).format("YYYY-MM-DD HH:00:00") })}
                          inputProps={{
                            inputProps: { step: 1800 , views:['year', 'month', 'day', 'hour']},
                          }}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <ApolloBasicRadio
                          id="repeatStatus"
                          label="繰り返しステータス"
                          options={options_edit_repeat_status}
                          value={report.repeatStatus}
                          control={control}
                          errors={errors}
                          setState={(e: any) => setReport({ ...report, repeatStatus: Number(e) })}
                        />
                      </Grid>
                    </Grid>
                  </>
                ) : null}

                <Grid container spacing={3}>
                  <Grid xs={5} justify="flex-end">
                    <Button
                      type="submit"
                      color="primary"
                      className={classes.button}
                      onClick={() => clearErrors()}
                      variant="contained"
                    >
                      予約設定更新
                    </Button>

                    <Button type="button" color="primary" variant="contained" onClick={handleGoback} className={classes.button}>
                      {"戻る"}
                    </Button>

                    <ApolloButtonBaseDelete handleButton={handleDelete} button="予約設定削除" title="予約設定削除" text={`この予約設定を削除しますか？`}/>
                  </Grid>
                </Grid>

              </CardContent>
            </Card>
          </form>

          <ApolloDialog open={openOutputColumnDialog} setOpen={setOpenOutputColumnDialog} onClose={handleCloseOutputColumn}>
            <ApolloOutputColumnDialog
              reportKind={report.reportKind}
              outputCaseLebel={report.outputCaseLebel}
              outputColumn={report.outputColumn}
              outputColumnsMaster={outputColumnsMaster}
              setPoints={setPoints}
              deletedSetPoints={deletedSetPoints}
              report={report}
              setReport={setReport}
              handleClose={handleCloseOutputColumn}
            />
          </ApolloDialog>

          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              title="作成済レポート"
              data={reports ? reports : []}
              columns={columns}
              options={{
                ...options,
                textLabels: {
                  body: { noMatch: "該当データが存在しません" },
                },
              }}
            />
          </Card>
        </Grid>
      </Grid>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default ReportDetail;
